"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildApplicationRefined = void 0;
const __1 = require("..");
const CreditRefined_1 = require("../Credit/CreditRefined");
const util_1 = require("util");
/**
 * Builds a full Application object after merging all required data rows together.
 * @param {(ApplicationProperties & ApplicationImmutableProperties)} application - The application's own data row
 * @param {ApplicationUserProperties[]} [assignees=[]]
 * @param {CreditProperties[]} [credits=[]] - Rows of data where PK = APPLICATION|<ID>, SK = CREDIT|<ID>
 * @param {(Applicant | null)} [applicant=null] - Applicant passed through to check for staleness
 * @return {*}  {Application}
 */
const buildApplicationRefined = (application, assignees = [], credits = [], applicant = null, // Pass through and applicant to assess if the application is stale
rules = []) => ({
    approve: application.approve,
    reject: application.reject,
    ID: application.ID,
    metadata: {
        created: application.metadata.created,
        updated: application.metadata.updated,
    },
    credits: credits.map(CreditRefined_1.buildCreditRefined),
    credentials: Object.values(application.credentials),
    applicant: application.applicant,
    files: application.files,
    links: application.links,
    suggestions: application.suggestions,
    access: application.access,
    course: application.course,
    program: application.program,
    delivery: application.delivery,
    lock: application.lock,
    verification: application.verification,
    priority: application.priority,
    submittedAt: application.submittedAt,
    institutionIdentifier: application.institutionIdentifier,
    customAttributes: application.customAttributes,
    workflowEntity: application.workflowEntity,
    staleSnapshot: applicant === null
        ? { applicant: false, credentials: false }
        : {
            applicant: Object.entries(application.applicant).every(([key, value]) => value === applicant[key] ||
                (typeof value === 'object' && JSON.stringify(value) === JSON.stringify(applicant[key]))),
            credentials: Object.values(application.credentials).length != applicant.credentials.length ||
                Object.values(application.credentials).some((cred) => {
                    const appcredential = applicant.credentials.find((c) => c.ID == cred.ID);
                    // If there is no matching credential, its definitly stale
                    if (!appcredential)
                        return true;
                    return !(0, util_1.isDeepStrictEqual)(appcredential, cred);
                }),
        },
    assignees: assignees.map((assignee) => ({ user: assignee.user, assigned: assignee.assigned })),
    rules: rules.map(__1.buildRuleResultRefined),
    acceptanceStatus: application.acceptanceStatus,
    lastCreditSearch: application.lastCreditSearch,
});
exports.buildApplicationRefined = buildApplicationRefined;
//# sourceMappingURL=ApplicationRefined.js.map